import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Lenis from "lenis";
import { toast } from "sonner";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import MarqueeStrip from "@/components/landing/MarqueeStrip";
import OfferGrid from "@/components/landing/OfferGrid";
import SignupForm from "@/components/landing/SignupForm";
import TermsSection from "@/components/landing/TermsSection";
import StoresSection from "@/components/landing/StoresSection";
import Footer from "@/components/landing/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
  const location = useLocation();
  const [user, setUser] = useState(location.state?.user || null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (location.state?.user) return;
    const checkAuth = async () => {
      try {
        const res = await axios.get(`${API}/auth/me`, { withCredentials: true });
        setUser(res.data);
      } catch {
        setUser(null);
      }
    };
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + window.location.pathname;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
    } catch {
      // session may already be gone server-side
    }
    setUser(null);
    toast.success("Signed out");
  };

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <div className="noise-overlay" aria-hidden />
      <Header user={user} onLogin={login} onLogout={logout} />
      <main>
        <Hero />
        <MarqueeStrip />
        <OfferGrid />
        <SignupForm user={user} onLogin={login} />
        <TermsSection />
        <StoresSection />
      </main>
      <Footer />
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}
